// extracted by css-extract-rspack-plugin
export default {"empty-state":"YzjF5R","emptyState":"YzjF5R"};